import { Component } from '@angular/core';
import { BaseComponent } from 'app/shared/infrastructure';
import { DynamicFormService } from 'app/shared/services/dynamicform/dynamicform.service';

@Component({
    selector: 'ba-dynamic-modules-menu',
    styleUrls: ['./baDynamicModulesMenu.component.scss'],
    templateUrl: './baDynamicModulesMenu.html',
})
export class baDynamicModulesMenuComponent extends BaseComponent {

    modules: any[] = [];

    constructor(private _dyncamicFormService: DynamicFormService) {
        super();
    }

    ngOnInit() {
        this._dyncamicFormService.getAllModules().subscribe({
            next: (res: any) => {
                this.modules = (res || [])
                    .filter((m: any) => this.validatePermission(`mod_${m.RouteTitle.trim().replace(/\s+/g, '_')}`))
                    .map((m: any) => ({
                        url: `/dynamicModule/${m.RouteTitle}`,
                        title: m.Name,
                        icon: 'fa-solid fa-cube',
                    }));
            },
            error: (err: any) => super.showError(err),
        });
    }

    openModule(item: any) {
        this.openLinkInNewTab(this.dynamicFormConstantUrl() + item.url);
    }
}